import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { getClient } from 'src/util/mdello-instance';
import { UseMutationInterface } from '../customers/mutations/interfaces/useUpdateCustomer.interface';

const deleteBox = async (requestId: string): Promise<void> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  await getClient()?.deleteEntity(
    {
      kind: EntityKind.REQUEST_ACTION,
      projectId: currentProject._id
    },
    requestId
  );
};

export const useDeleteBox = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation((requestId: string) => deleteBox(requestId), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
